import { NgModule } from '@angular/core';
import { MODALS } from '@freelancer/ui/modal';

@NgModule({
  providers: [
    {
      provide: MODALS,
      useValue: () =>
        import('./components-modal-routes').then(m => m.componentsModals),
      multi: true,
    },
  ],
})
export class ComponentsModalsModule {}
